export const formatPercentage = (percent: number, precision = 0): string =>
  (percent * 100).toFixed(precision) + '%'

/**
 * @param {number} numCompleted - number currently completed
 * @param {number} numForGoal - number needed to reach goal
 * @return {number} overall percentage completed based on goal and current number completed
 */
export const getPercentageCompleted = (
  numCompleted: number,
  numForGoal: number,
): number => {
  // If numForGoal is for some reason 0 avoid a dividing by 0 error
  if (numForGoal === 0) {
    return 0
  }
  return numCompleted >= numForGoal ? 100 : (numCompleted / numForGoal) * 100
}
